import Component from '../../lib/component'
import Autocomplete from '@trevoreyre/autocomplete-js'

export default class AutocompleteComponent extends Component {
    static selector () {
        return '.autocomplete'
    }

    constructor (opts) {
        super(opts)

        this.cludoBaseUrl = this.props.cludoBaseUrl
            || 'https://api-us1.cludo.com/api/v3'

        this.cludoApiEndpoint = this.props.cludoCustomerId
                && this.props.cludoEngineId
            ? `${this.cludoBaseUrl}/${
                this.props.cludoCustomerId}/${
                this.props.cludoEngineId}`
            : null

        if (!this.props.position)
            this.props.position = 'below'

        this.dialogModalParent = null
        this.props.dialogModalParent = this.isDialogModalParent()

        this.Autocomplete = new Autocomplete(this.el, {
            search: this.onSearch.bind(this),
            renderResult: this.onRenderResult.bind(this)
        })

        this.render()
        this.listen()
    }

    listen () {
        this.on('resize', () => this.render())
    }

    onSearch (value) {
        if (!(value || '').trim().length)
            return []

        if (this.cludoApiEndpoint)
            return window
                .fetch(`${this.cludoApiEndpoint}/autocomplete?text=${value}`, {
                    method: 'GET',
                    headers: {
                        Authorization: this.getCludoAuthHeader(),
                        'Content-Type': 'application/json'
                    }
                })
                .then(res => res.json())
                .then(data => data || [])

        return 'search' in this.el
                && typeof this.el.search === 'function'
            ? Promise.resolve(this.el.search())
            : []
    }

    onRenderResult (result, props) {
        const value = (this.getInput() || {}).value || ''

        result = value
            ? result
                .replace(new RegExp(`(${value})`, 'i'), '<strong>$1</strong>')
            : result

        const spanAttrs = this.props.dialogModalParent === 'true'
            ? ' class="container"'
            : ''

        return `<li ${props}><span${spanAttrs}>${result}</span></li>`
    }

    isDialogModalParent () {
        let isModal = false
        let el = this.el.parentElement

        while (el !== document.body) {
            if (el.getAttribute('data-expanded')) {
                isModal = true
                break
            }

            el = el.parentElement
        }

        if (isModal)
            this.dialogModalParent = el

        return isModal
    }

    getCludoAuthHeader () {
        return this.props.cludoCustomerId && this.props.cludoEngineId
            ? `SiteKey ${window.btoa(`${
                this.props.cludoCustomerId}:${
                this.props.cludoEngineId}:SearchKey`)}`
            : null
    }

    getInput () {
        return this.el.querySelector('.autocomplete-input')
    }

    getResultList () {
        return this.el.querySelector('.autocomplete-result-list')
    }

    render () {
        const resultList = this.getResultList()

        if (resultList
                && !resultList.classList
                    .contains('unstyled'))
            resultList.classList
                .add('unstyled')

        if (this.props.dialogModalParent !== 'true'
                || !this.dialogModalParent
                || !resultList)
            return

        const dialogTop = this.dialogModalParent.style.top || '0px'

        if (!this.el.clientHeight)
            return

        const maxHeight
            = `calc(100vh - (${dialogTop} + ${this.el.clientHeight}px))`

        if (resultList.style.maxHeight !== maxHeight)
            resultList.style.maxHeight = maxHeight
    }
}
